<mat-form-field fzFullWidth>
  <mat-label>
    <ng-content select="mat-label"></ng-content>
  </mat-label>
  <input
    matInput
    type="text"
    [formControl]="formControl"
    [value]="address"
    [matAutocomplete]="address"
  />
  <!-- Autocomplete -->
  <mat-autocomplete #address="matAutocomplete">
    <mat-option
      *ngFor="let suggestion of suggestions$ | async"
      [value]="suggestion.label"
      (click)="onChoseSuggestion(suggestion)"
    >
      {{ suggestion.label }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
